<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Contratos Vigentes</span>
                </h4>
                    <b-row>
                     <b-col sm="12" md="3" lg="3" xl="3">
                        <b-form-group>
                            <label>Ano</label>
                            <date-picker
                                v-model="ano"
                                :config="{ format: 'YYYY' }"
                                @change="handleYearSelection"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="4" xl="4">
                        <b-form-group>
                            <label>Gestor</label>
                            <b-form-select
                                :plain="true"
                                :options="responsaveis"
                                text-field="nome"
                                value-field="codFuncionario"
                                v-model="responsavel"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="4" xl="4">
                        <b-form-group>
                            <label>Unidade</label>
                            <b-form-select
                                :plain="true"
                                :options="unidades"
                                text-field="nome"
                                value-field="codUnidade"
                                v-model="unidade"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="obterContratosVigentes()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Relatório</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import RelatoriosServicos from './RelatoriosServicos'

export default {

    data() {
        return {
            ano: null,
            responsaveis: [],
            unidades: [],
            responsavel: null,
            unidade: null
        }
    },

    methods: {
         obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ru').then((response) => {
                if (response) {
                    if (response.success) {
                        this.responsaveis = response.data.Funcionarios
                        this.responsaveis.unshift({
                            codFuncionario: null,
                            nome: 'TODOS'
                        })
                        this.unidades = response.data.Unidades
                        this.unidades.unshift({
                            codUnidade: null,
                            nome: 'TODAS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterContratosVigentes() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                ano: this.ano,
                responsavel: this.responsavel,
                unidade: this.unidade
            }
            RelatoriosServicos.obterContratosVigentesPorAno(
               filtroDto
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'ContratosVigentes.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        handleYearSelection(value) {
            this.ano = value.getFullYear();
        }
    },

    mounted() {
        this.obterFiltrosOpcoes()

    }
}
</script>
